<template>
  <div :class="`card-info card-info-add`">
    <div class="shadow-wrapper" @click="close"></div>
    <div class="content">
      <div >
        <card class="card-modal" :title="$store.state.text.new_element">
          <div class="card-modal-bg"></div>
          <div>
            <form @submit.prevent>

              <fields-list :fields="fields" :item="item" />
             
              <div class="clearfix"></div>

              <div class="save-panel">
                <svg class="svg-angle svg-angle-1" width="30" height="30" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
                <svg class="svg-angle svg-angle-2" width="30" height="30" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
                 <p-button
                  class=" mr-2"
                  round
                  @click.native.prevent="close($event, true)"
                  ><span class="ti-arrow-left mr-2"></span>Назад</p-button
                >
                <p-button
                  class=""
                  type="info"
                  @click.native.prevent="addItem"
                  >{{'add' | setText('Добавить')}}</p-button
                >
     
              </div>
            </form>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { errorNotify, multiKeyInit, cardUpdate } from "@/plugins/functions";

export default {
  created() {
    let item = {};
    this.fields = [];
    this.fields = this.fieldsFrom.slice();

    for (let i = 0; i < this.fields.length; i++) {
      item[this.fields[i].key] = "";
    }

    this.item = this.multiKeyInit(item, this, 0);
  },
  data() {
    return {
      item: {},
      fields:[]
    };
  },
  props: {
    setLink: {
      default: "",
    },
    cardLink: {
      default: "",
    },
    openItem: {
      default: true,
    },
    modalTitle: {
      default: "",
    },
    modalCreate: {
      default: "",
    },
    fieldsFrom: {
      type: Array,
      default: {
        function(prams) {
          return [];
        },
      },
    },
    onCreateOpen: {
      default: true,
    },
    getList: {
      default: function () {
        return false;
      },
    },
  },
  methods: {
    multiKeyInit: multiKeyInit,
    errorNotify: errorNotify,
    cardUpdate: cardUpdate,
    close() {
      this.item = {};
      this.$emit('close',true);
    },
    modalOpen() {
      
    },
    async addItem() {
      let item = await this.cardUpdate(this.setLink, this.item, this.fields, 'POST' );
      if(item && item.result){
        // this.$emit('getList');
        this.close()
        this.getList()
        console.log(item, 'item', this.item, this.setLink, this.getList)
        return 
      }
      if (item && item.id){
           this.close();

           if( this.openItem === true ){
            let query = Object.assign({}, this.$route.query);
            if (query[this.cardLink]) {
              delete query[this.cardLink];
            }
            query[this.cardLink] = item.id;
            setTimeout(() => {
              this.$router.replace({ query: query });
            }, 20);
            }
      }
    },
    // dev
    // async addItem() {
    //   let item = await this.cardUpdate(this.setLink, this.item, this.fields, 'POST' );

    //   if (item && item.id){
    //       this.$emit('close',true);

    //        if( this.openItem === true ){
    //         let query = Object.assign({}, this.$route.query);
    //         if (query[this.cardLink]) {
    //           delete query[this.cardLink];
    //         }
    //         query[this.cardLink] = item.id;
    //         setTimeout(() => {
    //           this.$router.replace({ query: query });
    //         }, 20);
    //         }
    //   }
    // },
  },
};
</script>